//@flow
import popOverFactory from 'common/components/core/popover/popOverFactory';
import Button from 'common/components/core/button/Button';
const ButtonWithPopover = popOverFactory({ Component: Button });
ButtonWithPopover.defaultProps = {
    ...ButtonWithPopover.defaultProps,
    enableTooltipOnHover: true
};

export default ButtonWithPopover;
export { ButtonWithPopover };
